import { useTranslation } from "react-i18next";
import { useState, useEffect } from 'react';
import { Program, AnchorProvider, setProvider, BN } from "@coral-xyz/anchor";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import {
  Connection,
  PublicKey,
  SystemProgram,
} from "@solana/web3.js";
import { TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID, getAssociatedTokenAddressSync } from "@solana/spl-token";
import airdropIDL from "../../idl/airdropIDL.json";
import presaleIDL from "../../idl/presaleIDL.json";
const PreSale = () => {

  const { t } = useTranslation();
  const [claimableAmount, setClaimableAmount] = useState("0");
  const [presaleProgram, setPresaleProgram] = useState();
  const [airdropProgram, setAirdropProgram] = useState();
  const [anchorProvider, setAnchorProvider] = useState();
  const [SOLAmount, setSOLAmount] = useState();
  const [receiveTokenAmount, setReceiveTokenAmount] = useState();
  const { connected } = useWallet();
  const [endTime, setEndTime] = useState(0);
  const [tokenPrice, setTokenPrice] = useState(0.0);
  const [soldTokenAmount, setSoldTokenAmount] = useState("0");
  const [depositTokenAmount, setDepositTokenAmount] = useState("0");
  // const { connection } = useConnection();
  const wallet = useAnchorWallet();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const AIRDROP_STATE_SEED = "AIRDROP-STATE-SEED";
  const GLOBAL_STATE_SEED = "GLOBAL-STATE-SEED";
  const VAULT_STATE_SEED = "VAULT-STATE-SEED";
  const VAULT_SEED = "VAULT-SEED";
  const PRESALE_STATE_SEED = "PRESALE-STATE-SEED";
  const USER_STATE_SEED = "USER-STATE-SEED";

  const authority = new PublicKey("FV6LFJX7YJVGR8toZ1tfzmkQbixsxRQ4KSAYHupZ3Nyr");
  const tokenMint = new PublicKey("DmTdFpNxqzeXihLLxtkpokbVqhPqPfmeAh6L74NZofuN");
  const instructionsSysvar = new PublicKey("Sysvar1nstructions1111111111111111111111111");
  const connection = new Connection('https://mainnet.helius-rpc.com/?api-key=6e54f6c2-1281-4bc7-8d64-c34c92f4b4e7');

  const identifier = 0;
  const identifierBN = new BN(identifier);
  const identifierLE = Buffer.from(identifierBN.toArray("le", 1));
  const calculateTimeLeft = () => {
    const difference = endTime * 1000 - Date.now();

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000)
    };
  };

  useEffect(() => {

    const _presaleProgram = new Program(presaleIDL, {
      connection,
    })
    const _airdropProgram = new Program(airdropIDL, {
      connection,
    })
    setPresaleProgram(_presaleProgram);
    setAirdropProgram(_airdropProgram);
    const [presaleStatePdaWithIdentifier] = PublicKey.findProgramAddressSync(
      [Buffer.from(PRESALE_STATE_SEED), identifierLE],
      _presaleProgram.programId
    );

    _presaleProgram.account.presaleState.fetch(presaleStatePdaWithIdentifier).then(presaleState => {
      setEndTime(presaleState.endTime.toNumber());
      setDepositTokenAmount(Number(presaleState.depositTokenAmount / new BN(10 ** 9)).toFixed(0));
      setSoldTokenAmount(Number(presaleState.soldTokenAmount / new BN(10 ** 9)).toFixed(2));
      setTokenPrice(Number(presaleState.solPricePerToken / new BN(10 ** 9)));
    });
  }, []);


  useEffect(() => {
    if (wallet) {
      const provider = new AnchorProvider(connection, wallet, {});
      setProvider(provider);
      setAnchorProvider(provider);

      const [userStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(USER_STATE_SEED), wallet.publicKey.toBuffer(), identifierLE],
        presaleProgram.programId
      );
      connection.getAccountInfo(userStatePda).then(accounInfo => {
        if (accounInfo) {
          presaleProgram.account.userState.fetch(userStatePda).then(userState => {
            setClaimableAmount(Number((new BN(userState.buyTokenAmount) - new BN(userState.claimAmount)) / new BN(10 ** 9)).toFixed(3))
          });
        }
      });
    }


  }, [wallet]);

  useEffect(() => {
    if (endTime) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      // Cleanup on component unmount
      return () => clearInterval(timer);
    }
  }, [endTime]);

  const [isBuying, setIsBuying] = useState(false);
  const [isClaiming, setIsClaiming] = useState(false);

  const handleBuy = async () => {
    if (!connected || isBuying) return;
    setIsBuying(true);
    try {
      console.log("Buy clicked");
      const [airdropStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(AIRDROP_STATE_SEED)],
        airdropProgram.programId
      );
      const [globalStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(GLOBAL_STATE_SEED)],
        presaleProgram.programId
      );
      const [vaultPda] = PublicKey.findProgramAddressSync(
        [Buffer.from(VAULT_SEED)],
        presaleProgram.programId
      );

      const [presaleStatePdaWithIdentifier] = PublicKey.findProgramAddressSync(
        [Buffer.from(PRESALE_STATE_SEED), identifierLE],
        presaleProgram.programId
      );
      const [userStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(USER_STATE_SEED), wallet.publicKey.toBuffer(), identifierLE],
        presaleProgram.programId
      );

      const transaction = await presaleProgram.methods
        .buyToken(identifier, new BN(Number(SOLAmount) * Math.pow(10, 9)))
        .accounts({
          user: wallet.publicKey,
          authority,
          instructionsSysvar,
          globalState: globalStatePda,
          presaleState: presaleStatePdaWithIdentifier,
          userState: userStatePda,
          vault: vaultPda,
          airdropState: airdropStatePda,
          airdropProgram: airdropProgram.programId,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
        })
        .transaction()

      const signature = await anchorProvider.sendAndConfirm(transaction, [], {
        commitment: 'confirmed',
      });

      console.log('Transaction confirmed with signature:', signature);
      await new Promise((resolve) => setTimeout(resolve, 15000));
      const userState = await presaleProgram.account.userState.fetch(userStatePda);
      console.log("userState claimAmount: ", userState.claimAmount.toString())
      console.log("userState buyTokenAmount: ", userState.buyTokenAmount.toString())
      console.log("diff: ", (new BN(userState.buyTokenAmount) - new BN(userState.claimAmount)).toString())
      setClaimableAmount(Number((new BN(userState.buyTokenAmount) - new BN(userState.claimAmount)) / new BN(10 ** 9)).toFixed(3))

    } catch (error) {
      console.error('transaction failed', error)
    } finally {
      setIsBuying(false);
    }
  };

  const handleClaim = async () => {
    if (!connected || isClaiming) return;
    setIsClaiming(true);
    try {
      console.log("Claim clicked");
      const [airdropStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(AIRDROP_STATE_SEED)],
        airdropProgram.programId
      );
      const [globalStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(GLOBAL_STATE_SEED)],
        presaleProgram.programId
      );
      const [vaultPda] = PublicKey.findProgramAddressSync(
        [Buffer.from(VAULT_SEED)],
        presaleProgram.programId
      );

      const [presaleStatePdaWithIdentifier] = PublicKey.findProgramAddressSync(
        [Buffer.from(PRESALE_STATE_SEED), identifierLE],
        presaleProgram.programId
      );
      const [userStatePda] = PublicKey.findProgramAddressSync(
        [Buffer.from(USER_STATE_SEED), wallet.publicKey.toBuffer(), identifierLE],
        presaleProgram.programId
      );
      const presaleTokenAccount = getAssociatedTokenAddressSync(tokenMint, presaleStatePdaWithIdentifier, true);
      const userTokenAccount = getAssociatedTokenAddressSync(tokenMint, wallet.publicKey, true);

      const transaction = await presaleProgram.methods
        .claimToken(identifier)
        .accounts({
          user: wallet.publicKey,
          globalState: globalStatePda,
          presaleState: presaleStatePdaWithIdentifier,
          userState: userStatePda,
          tokenMint,
          presaleTokenAccount,
          userTokenAccount,
          tokenProgram: TOKEN_PROGRAM_ID,
          associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
        })
        .transaction()

      const signature = await anchorProvider.sendAndConfirm(transaction, [], {
        commitment: 'confirmed',
      });

      console.log('Transaction confirmed with signature:', signature);
      await new Promise((resolve) => setTimeout(resolve, 15000));
      const userState = await presaleProgram.account.userState.fetch(userStatePda);
      setClaimableAmount(Number((new BN(userState.buyTokenAmount) - new BN(userState.claimAmount)) / new BN(10 ** 9)).toFixed(3))

    } catch (error) {
      console.error('transaction failed', error)
    } finally {
      setIsClaiming(false);
    }
  };

  return (
    <div id="Presale"
      className="px-4 sm:px-10 flex lg:flex-row flex-col relative min-h-screen"
    >
      <div className="flex flex-col p-10 w-full justify-center items-center px-3 lg:px-10">

        <div className="relative flex items-center justify-center mb-10" id="roadmap">
          <div className="container mx-auto px-4 max-w-[300px] sm:max-w-[400px] lg:max-w-[500px]">
            <a
              href="https://solscan.io/token/DmTdFpNxqzeXihLLxtkpokbVqhPqPfmeAh6L74NZofuN"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-[#0AF9FF] text-center text-xl lg:text-2xl font-bold animate-slide-in opacity-0 hover:text-[#22C8BF] transition-colors duration-300 hover:underline overflow-hidden text-ellipsis whitespace-nowrap"
              style={{ animationDelay: '0.3s', animationFillMode: 'forwards' }}
            >
              DmTdFpNxqzeXihLLxtkpokbVqhPqPfmeAh6L74NZofuN
            </a>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-3 border border-[#0AF9FF] py-6 border-opacity-30 rounded-md hover:border-opacity-50 transition-all duration-300 transform hover:scale-[1.01] hover:shadow-[0_0_15px_rgba(10,249,255,0.15)]">
          <p className="text-2xl text-[#0AF9FF] hover:text-[#0AF9FF]/80 transition-colors duration-300">
            $CPH PRE-SALE
          </p>
          <p className="text-lg text-white hover:text-[#0AF9FF] transition-colors duration-300">
            {t('content2.nextPrice')}
          </p>
          <div className="w-full flex flex-col justify-center items-center relative mt-6">
            <div className="grid grid-cols-4 gap-2 w-full">
              {[
                { label: "Days", value: timeLeft.days, padLength: 3 },
                { label: "Hours", value: timeLeft.hours, padLength: 2 },
                { label: "Minutes", value: timeLeft.minutes, padLength: 2 },
                { label: "Seconds", value: timeLeft.seconds, padLength: 2 }
              ].map((item, index) => (
                <div key={item.label}
                  className="bg-[#051110] flex flex-col justify-center items-center p-4 transform hover:scale-105 transition-all duration-300 hover:shadow-[0_0_15px_rgba(10,249,255,0.15)] hover:bg-[#051110]/80"
                  style={{
                    animation: `fadeInScale 0.5s ease-out ${index * 0.1}s backwards`
                  }}
                >
                  <p className="text-white text-sm mb-2 hover:text-[#0AF9FF] transition-colors duration-300">
                    {item.label}
                  </p>
                  <p className="text-white text-3xl font-medium hover:text-[#0AF9FF] transition-colors duration-300">
                    {item.value.toString().padStart(item.padLength, '0')}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center w-full px-6 gap-4 mt-4">
            <div className="w-full flex justify-between items-center text-white text-lg mb-1 hover:text-[#0AF9FF] transition-colors duration-300">
              <p className="font-semibold transform hover:scale-105 transition-transform duration-300">{soldTokenAmount} $CPH</p>
              <p className="font-semibold transform hover:scale-105 transition-transform duration-300">{depositTokenAmount} $CPH </p>
            </div>
            <div className="relative w-full">
              {/* Background line */}
              <div className="w-full h-[1px] bg-white/30">
                {/* Active progress line */}
                <div
                  className="absolute left-0 top-0 h-[1px] bg-[#22C8BF]"
                  style={{
                    width: `${(soldTokenAmount / depositTokenAmount * 100) || 70}%`
                  }}
                />
                {/* Progress dot */}
                <div
                  className="absolute top-1/2 -translate-y-1/2 w-[6px] h-[6px] bg-[#22C8BF] rounded-full shadow-[0_0_8px_rgba(34,200,191,0.5)]"
                  style={{
                    left: `${(soldTokenAmount / depositTokenAmount * 100) || 70}%`
                  }}
                />
              </div>
            </div>
          </div>
          <p className="text-white text-lg mt-2 hover:text-[#0AF9FF] transition-colors duration-300 transform hover:scale-105">
            1 CPH = {tokenPrice} SOL
          </p>
          <div className="w-full flex lg:flex-row flex-col gap-4">
            <div className="flex justify-between items-center bg-[#051110] py-6 px-8 w-full hover:bg-[#051110]/80 transition-all duration-300 transform hover:scale-[1.02]">
              <div className="w-full group">
                <p className="text-white mb-2 group-hover:text-[#0AF9FF] transition-colors duration-300">Buy With</p>
                <input
                  onChange={(event) => {
                    const newValue = event.target.value;
                    if (/^[-+]?[0-9]*\.?[0-9]*(e[-+]?[0-9]*)?$/i.test(newValue) || newValue === "") {
                      setSOLAmount(newValue);
                      setReceiveTokenAmount((Number(newValue) / tokenPrice).toFixed(3))
                    }
                  }}
                  type="number"
                  style={{ fontSize: '22px' }}
                  className="w-full bg-transparent border-none text-white font-medium text-xl focus:outline-none focus:border-transparent group-hover:text-[#0AF9FF] transition-colors duration-300"
                  placeholder="0"
                />
              </div>
              <div className="w-full flex justify-end items-center gap-2 group">
                <img
                  alt="Solana Icon from Simple Icons Set"
                  width="50"
                  height="50"
                  className="transform group-hover:scale-110 transition-transform duration-300 rounded-full"
                  src="https://img-v1.raydium.io/icon/So11111111111111111111111111111111111111112.png"
                />
                <p className="text-white text-xl font-medium group-hover:text-[#0AF9FF] transition-colors duration-300">SOL</p>
              </div>
            </div>
            <div className="flex justify-between items-center bg-[#051110] py-6 px-8 w-full hover:bg-[#051110]/80 transition-all duration-300 transform hover:scale-[1.02]">
              <div className="group">
                <p className="text-white mb-2 group-hover:text-[#0AF9FF] transition-colors duration-300">Receive(estimated)</p>
                <input
                  type="number"
                  value={receiveTokenAmount}
                  style={{ fontSize: '22px' }}
                  readOnly
                  className="w-full bg-transparent border-none text-white font-medium text-xl focus:outline-none focus:border-transparent group-hover:text-[#0AF9FF] transition-colors duration-300"
                  placeholder="0"
                />
              </div>
              <div className="flex justify-center items-center gap-2 group">
                <img
                  src="/static/images/Cph.svg"
                  width="50"
                  height="50"
                  className="transform group-hover:scale-110 transition-transform duration-300"
                  alt="taptool"
                />
                <p className="text-white text-xl font-medium group-hover:text-[#0AF9FF] transition-colors duration-300">CPH</p>
              </div>
            </div>
          </div>
          {connected ? (
            <div className="w-full flex flex-col gap-4">
              <div className="flex justify-between w-full items-center py-4 px-6 hover:bg-[#051110]/50 transition-all duration-300 rounded-md">
                <span className="text-white text-lg hover:text-[#0AF9FF] transition-colors duration-300">Claimable CPH:</span>
                <span className="text-[#0AF9FF] font-medium text-lg transform hover:scale-110 transition-transform duration-300">{claimableAmount} CPH</span>
              </div>
              <div className="flex gap-4 w-full">
                <button
                  onClick={handleBuy}
                  disabled={isBuying}
                  className={`flex-1 bg-[#051110] text-white font-medium py-4 px-8 border border-[#0AF9FF]/20 
                  hover:border-[#0AF9FF] hover:bg-[#0AF9FF]/10 transition-all duration-300 
                  active:transform active:scale-[0.98] relative group overflow-hidden
                  disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-[#0AF9FF]/20 disabled:hover:bg-[#051110]
                  hover:shadow-[0_0_15px_rgba(10,249,255,0.3)] transform hover:scale-[1.02]`}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0AF9FF]/0 via-[#0AF9FF]/5 to-[#0AF9FF]/0 
                  transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                  <span className="relative flex items-center justify-center gap-2">
                    {isBuying ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span className="animate-pulse">Processing...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-5 h-5 transform group-hover:rotate-180 transition-transform duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Buy Token
                      </>
                    )}
                  </span>
                </button>
                <button
                  onClick={handleClaim}
                  disabled={isClaiming}
                  className={`flex-1 bg-[#051110] text-white font-medium py-4 px-8 border border-[#0AF9FF]/20 
                  hover:border-[#0AF9FF] hover:bg-[#0AF9FF]/10 transition-all duration-300 
                  active:transform active:scale-[0.98] relative group overflow-hidden
                  disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-[#0AF9FF]/20 disabled:hover:bg-[#051110]
                  hover:shadow-[0_0_15px_rgba(10,249,255,0.3)] transform hover:scale-[1.02]`}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0AF9FF]/0 via-[#0AF9FF]/5 to-[#0AF9FF]/0 
                  transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                  <span className="relative flex items-center justify-center gap-2">
                    {isClaiming ? (
                      <>
                        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span className="animate-pulse">Processing...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-5 h-5 transform group-hover:rotate-180 transition-transform duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Claim Token
                      </>
                    )}
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div className="flex gap-4 w-full">
              <button
                disabled
                className="flex-1 bg-[#0AF9FF]/50 font-medium py-3 px-6 text-black/50 cursor-not-allowed transform hover:scale-105 transition-transform duration-300"
              >
                Connect Wallet to Buy
              </button>
              <button
                disabled
                className="flex-1 border border-[#0AF9FF]/50 text-[#0AF9FF]/50 font-medium py-3 px-6 cursor-not-allowed transform hover:scale-105 transition-transform duration-300"
              >
                Connect Wallet to Claim
              </button>
            </div>
          )}
        </div>
      </div>

    </div>
  )
}

export default PreSale;